import { useEffect, useRef, useState } from "react";
import { useContentMulti } from "@/hooks/useContent";

const partnerLogos: { name: string; slug?: string; src?: string }[] = [
  { name: "Microsoft", src: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M0 0h11.5v11.5H0zM12.5 0H24v11.5H12.5zM0 12.5h11.5V24H0zM12.5 12.5H24V24H12.5z'/%3E%3C/svg%3E" },
  { name: "AWS", src: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M6.763 10.036c0 .296.032.535.088.71.064.176.144.368.256.576.04.063.056.127.056.183 0 .08-.048.16-.152.24l-.503.335a.383.383 0 0 1-.208.072c-.08 0-.16-.04-.239-.112a2.47 2.47 0 0 1-.287-.375 6.18 6.18 0 0 1-.248-.471c-.622.734-1.405 1.101-2.347 1.101-.67 0-1.205-.191-1.596-.574-.391-.384-.59-.894-.59-1.533 0-.678.239-1.23.726-1.644.487-.415 1.133-.623 1.955-.623.272 0 .551.024.846.064.296.04.6.104.918.176v-.583c0-.607-.127-1.03-.375-1.277-.255-.248-.686-.367-1.3-.367-.28 0-.568.032-.863.104-.296.072-.583.16-.862.272a2.287 2.287 0 0 1-.28.104.488.488 0 0 1-.127.023c-.112 0-.168-.08-.168-.247v-.391c0-.128.016-.224.056-.28a.597.597 0 0 1 .224-.167c.279-.144.614-.264 1.005-.36a4.84 4.84 0 0 1 1.246-.152c.95 0 1.644.216 2.091.647.44.43.662 1.085.662 1.963v2.586zm-3.24 1.214c.263 0 .534-.048.822-.144.287-.096.543-.271.758-.51.128-.152.224-.32.272-.512.047-.191.08-.423.08-.694v-.335a6.66 6.66 0 0 0-.735-.136 6.02 6.02 0 0 0-.75-.048c-.535 0-.926.104-1.19.32-.263.215-.39.518-.39.917 0 .375.095.655.295.846.191.2.47.296.838.296zm6.41.862c-.144 0-.24-.024-.304-.08-.064-.048-.12-.16-.168-.311L7.586 5.55a1.398 1.398 0 0 1-.072-.32c0-.128.064-.2.191-.2h.783c.151 0 .255.025.31.08.065.048.113.16.16.312l1.342 5.284 1.245-5.284c.04-.16.088-.264.151-.312a.549.549 0 0 1 .32-.08h.638c.152 0 .256.025.32.08.063.048.12.16.151.312l1.261 5.348 1.381-5.348c.048-.16.104-.264.16-.312a.52.52 0 0 1 .311-.08h.743c.128 0 .2.065.2.2 0 .04-.009.08-.017.128a1.137 1.137 0 0 1-.056.2l-1.923 6.17c-.048.16-.104.264-.168.312a.549.549 0 0 1-.32.08h-.687c-.152 0-.256-.024-.32-.08-.063-.056-.12-.16-.15-.32l-1.239-5.14-1.23 5.133c-.04.16-.087.271-.15.327-.064.056-.176.08-.32.08zm10.256.215c-.415 0-.83-.048-1.229-.143-.399-.096-.71-.2-.918-.32-.128-.071-.216-.151-.248-.223a.504.504 0 0 1-.048-.224v-.407c0-.167.064-.247.183-.247.048 0 .096.008.144.024.048.016.12.048.2.08.271.12.566.215.878.279.319.064.63.096.95.096.502 0 .894-.088 1.165-.264a.86.86 0 0 0 .415-.758.777.777 0 0 0-.215-.559c-.144-.151-.415-.287-.806-.415l-1.157-.36c-.583-.183-1.014-.454-1.277-.813a1.902 1.902 0 0 1-.4-1.158c0-.335.073-.63.216-.886.144-.255.335-.479.575-.654.24-.184.51-.32.83-.415.32-.096.655-.136 1.006-.136.176 0 .359.008.535.032.183.024.35.056.518.088.16.04.312.08.455.127.144.048.256.096.336.144a.69.69 0 0 1 .24.2.43.43 0 0 1 .071.263v.375c0 .168-.064.256-.184.256a.83.83 0 0 1-.303-.096 3.652 3.652 0 0 0-1.532-.311c-.455 0-.815.071-1.062.223-.248.152-.375.383-.375.71 0 .224.08.416.24.567.16.152.454.304.87.44l1.133.358c.574.184.99.44 1.237.767.247.327.367.702.367 1.117 0 .343-.072.655-.207.926-.144.272-.336.511-.583.703-.248.2-.543.343-.886.447-.36.111-.734.167-1.142.167z'/%3E%3Cpath d='M21.725 16.166C19.31 17.99 15.786 18.96 12.759 18.96c-4.27 0-8.114-1.58-11.023-4.206-.228-.207-.024-.49.25-.328 3.14 1.826 7.021 2.926 11.031 2.926 2.703 0 5.677-.559 8.418-1.717.415-.176.76.272.29.531zM22.563 15.197c-.311-.399-2.06-.191-2.846-.096-.239.032-.271-.176-.056-.327 1.389-.974 3.672-.694 3.937-.367.264.335-.072 2.627-1.373 3.725-.2.168-.391.08-.303-.144.295-.726.95-2.386.64-2.791z' /%3E%3C/svg%3E" },
  { name: "Google Cloud", slug: "googlecloud" },
  { name: "Cisco", slug: "cisco" },
  { name: "Apple", slug: "apple" },
  { name: "Dell Technologies", slug: "dell" },
  { name: "HP", slug: "hp" },
  { name: "Lenovo", slug: "lenovo" },
  { name: "Intel", slug: "intel" },
  { name: "AMD", slug: "amd" },
  { name: "Anthropic", slug: "anthropic" },
  { name: "Google Gemini", slug: "googlegemini" },
  { name: "Perplexity", slug: "perplexity" },
];

function AnimatedCounter({ target, suffix }: { target: number; suffix: string }) {
  const [count, setCount] = useState(0);
  const ref = useRef<HTMLDivElement>(null);
  const started = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;
          let current = 0;
          const step = Math.max(1, Math.floor(target / 40));
          const interval = setInterval(() => {
            current += step;
            if (current >= target) { current = target; clearInterval(interval); }
            setCount(current);
          }, 30);
        }
      },
      { threshold: 0.5 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [target]);

  return (
    <div ref={ref} className="text-center">
      <div className="font-display text-3xl sm:text-4xl md:text-5xl font-bold text-primary">
        {count}{suffix}
      </div>
    </div>
  );
}

const TrustedPartners = () => {
  const c = useContentMulti({
    "why.stat1_value": "200", "why.stat1_suffix": "+", "why.stat1_label": "Clients Served",
    "why.stat2_value": "99", "why.stat2_suffix": "%", "why.stat2_label": "Uptime Guarantee",
    "why.stat3_value": "30", "why.stat3_suffix": "+", "why.stat3_label": "Years Experience",
    "why.stat4_value": "24", "why.stat4_suffix": "/7", "why.stat4_label": "Support Available",
  });

  const stats = [
    { value: parseInt(c["why.stat1_value"]) || 200, suffix: c["why.stat1_suffix"], label: c["why.stat1_label"] },
    { value: parseInt(c["why.stat2_value"]) || 99, suffix: c["why.stat2_suffix"], label: c["why.stat2_label"] },
    { value: parseInt(c["why.stat3_value"]) || 30, suffix: c["why.stat3_suffix"], label: c["why.stat3_label"] },
    { value: parseInt(c["why.stat4_value"]) || 24, suffix: c["why.stat4_suffix"], label: c["why.stat4_label"] },
  ];

  return (
    <section className="py-16 md:py-20 bg-background">
      <div className="container mx-auto px-4">
        <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-12">
          Trusted by <span className="text-primary">Businesses</span> Across Southern California
        </h2>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto mb-16">
          {stats.map((s) => (
            <div key={s.label}>
              <AnimatedCounter target={s.value} suffix={s.suffix} />
              <p className="text-sm text-muted-foreground text-center mt-2">{s.label}</p>
            </div>
          ))}
        </div>

        {/* Scrolling partner logos */}
        <p className="text-base md:text-lg uppercase tracking-[0.2em] text-muted-foreground text-center mb-2 font-display">Our Technology Partners</p>
        <div className="w-12 h-1 bg-primary mx-auto mb-6 rounded-full" />
        <div className="overflow-hidden">
          <div className="flex icon-marquee" style={{ animationDuration: '40s' }}>
            <div className="flex shrink-0">
              {partnerLogos.map((logo) => (
                <img
                  key={logo.name}
                  src={logo.src || `https://cdn.simpleicons.org/${logo.slug}/white`}
                  alt={logo.name}
                  width={32}
                  height={32}
                  className="h-8 mx-8 opacity-60 hover:opacity-100 transition-opacity duration-300"
                  loading="lazy"
                  onError={(e) => { e.currentTarget.style.display = 'none'; }}
                />
              ))}
            </div>
            <div className="flex shrink-0" aria-hidden="true">
              {partnerLogos.map((logo) => (
                <img
                  key={`${logo.name}-dup`}
                  src={logo.src || `https://cdn.simpleicons.org/${logo.slug}/white`}
                  alt=""
                  width={32}
                  height={32}
                  className="h-8 mx-8 opacity-60 hover:opacity-100 transition-opacity duration-300"
                  loading="lazy"
                  onError={(e) => { e.currentTarget.style.display = 'none'; }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustedPartners;
